export default (value: unknown): value is undefined => value === undefined;
